export const GET_FAQ_REQUEST = "get_faq_request";
export const GET_FAQ_SUCCESS = "get_faq_success";
export const GET_FAQ_FAILURE = "get_faq_failure";
